import React, { FC } from 'react';
import { PageHeading } from 'src/common';
import { faBuilding } from '@fortawesome/pro-light-svg-icons';
import { useTranslation } from 'react-i18next';
import BuyersCat from './Buyers';
import styles from './index.module.scss';
import { FeatureFlag, useFeatureFlag } from 'src/helpers/featureFlag';
import { Navigate } from 'react-router-dom';
import { Paths } from 'src/pages/paths';

export const BuyerProfilesHomePage: FC = () => {
  const { t } = useTranslation();
  const isBuyerProfilesHomePageAvailable = useFeatureFlag(FeatureFlag.AnalyticsHomepage);

  return !!isBuyerProfilesHomePageAvailable ? (
    <>
      <PageHeading
        title={t('Navigation.buyerProfiles')}
        desc={t('BuyerProfiles.buyerProfilesDesc')}
        icon={faBuilding}
      />
      <div className={styles.content}>
        <BuyersCat />
      </div>
    </>
  ) : (
    <Navigate to={Paths.HOME_PATH} />
  );
};

export default BuyerProfilesHomePage;
